<template>
	<div>
		<div class="ft20 cl-main ftw600">数据角色管理</div>
		
		<div class="form-search-box mt20 ">
			<a-form layout="inline">
				<a-form-item label="角色名称">
					<a-input v-model="search.keywords" placeholder="请输入角色名称"></a-input>
				</a-form-item>
				
				<a-form-item>
					<a-button @click="searchAct" type="primary">查询</a-button>
					<a-button @click="cancelAct" class="ml10">取消</a-button>
				</a-form-item>
			</a-form>
		</div>
		
		<div class="mt20">
			<div class="pd20 bg-w " style="min-height: 800px;">
				<div class="">
					<a-button type="primary" icon="plus" @click="add()">添加数据角色</a-button>
				</div>
				
				<div class="mt20">
					<div class="wxb-table-gray">
						<a-table rowKey="id" :columns="columns" :pagination="pagination" @change="handleTableChange"
							:data-source="datas" :loading="loading">
                            <template slot="purview_list" slot-scope="record">
								<div class="shop-list" v-if="record.role_type.value == 'shop'">
                                    <span v-for="(item, index) in record.purview_list.slice(0, 5)" :key="index">{{index == 4 || (index+1 == record.purview_list.length)  ? item.name : item.name + '，'}}</span>
                                    <a class="fs16 ml5" href="javascript:;" v-if="record.purview_list.length > 5" @click="view(record.purview_list)"><a-icon type="ellipsis" /></a>
                                </div>
							</template>
							<template slot="action" slot-scope="record">
								<div class="flex center">
									<a class="bd-sky-blue fs12" href="javascript:;" @click="edit(record)">
										<span>编辑</span>
									</a>
									<a class="bd-red fs12" href="javascript:;" @click="del(record)">
										<span>删除</span>
									</a>
								</div>
							</template>
						</a-table>
					</div>
				</div>
			</div>
		</div>
        <div v-if="showShopList">
            <shop-list :shopList="shopList" :visible="showShopList" @cancel="closeShopList"></shop-list>
        </div>
	</div>
</template>

<script>
    import shopList from '../../components/roles/modal/ShopList.vue';
	export default{
        components:{
			shopList,
		},
		data(){
			return {
				loading: false,
                showShopList: false,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keywords: '',
					status: -1,
				},
				columns: [
					{title: 'ID',dataIndex: 'id',align: 'center'},
					{title: '角色名称',dataIndex: 'role_name',align: 'center'},
                    {title: '店铺',key: 'purview_list',align: 'left',scopedSlots: {customRender: 'purview_list'}},
					{title: '排序',dataIndex: 'sort',align: 'center'},
					{title: '状态',dataIndex: 'status.text',align: 'center'},
					{title: '添加时间',dataIndex: 'create_time',align: 'center'},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas: [],
                shopList: [],
			}
		},
        created(){
            this.getLists();
        },
		methods:{
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('platform/account/role/getDataRoleList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					keywords:this.search.keywords,
                    role_type: 'shop'
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			del(record){
				this.$confirm({
					title:'确认删除当前角色吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/account/role/delData',{
								id: record.id,
                                role_type: record.role_type.value
							}).then(res=>{
								this.$message.success('删除成功',1,()=>{
									this.getLists();
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			changeType() {
				this.pagination.current = 1;
				this.getLists();
			},
			
			//添加
			add(){
				this.$router.push('/setting/roles/data/edit')
			},
			edit(record){
				this.$router.push('/setting/roles/data/edit?id='+ record.id)
			},
            view(shopList){
                this.shopList = shopList;
                this.showShopList = true;
            },
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
            closeShopList(){
                this.shopList = [];
                this.showShopList = false;
            }
		}
	}
</script>

<style>
</style>
